module.exports = __webpack_public_path__ + "packs/media/images/palestraBoulder2 copy-819a95fed891e461843724ddfecbc3ae.jpg";